var map = {
	"./components/templates/groupAffiliates.html": 787,
	"./components/templates/groupGamesItem.html": 3388,
	"./components/templates/groupMembersList.html": 4429,
	"./directives/templates/groupAbout.html": 3748,
	"./directives/templates/groupBase.html": 2339,
	"./directives/templates/groupCatalogItem.html": 9405,
	"./directives/templates/groupComments.html": 1137,
	"./directives/templates/groupCommentsMenuPopover.html": 8406,
	"./directives/templates/groupGames.html": 7282,
	"./directives/templates/groupMenuPopover.html": 9052,
	"./directives/templates/groupStore.html": 932,
	"./directives/templates/groupStoreItem.html": 8347,
	"./directives/templates/groupWall.html": 6711,
	"./directives/templates/leaveGroupModal.html": 5434,
	"./directives/templates/reportAbuseModal.html": 564
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6735;